<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitRequest)">
        <div class="card p-10 pt-15 b-t-1-869fb229" style="overflow-x: hidden; overflow-y: auto">
          <ValidationProvider rules="required" vid="serial" name="serial">
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label">
                Serial<span style="color: red"> *</span>
              </label>
              <div class="col-sm-9">
                <input type="text" :disabled="isEdit" v-model="dataRequest.serial" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider
            v-if="!isEdit || type === 'device'"
            rules="required"
            vid="deviceType"
            name="Loại thiết bị"
          >
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label">
                Loại thiết bị<span style="color: red"> *</span>
              </label>
              <div class="col-sm-9">
                <Select2 v-model="dataRequest.deviceType" :options="deviceTypeOptions" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider
            v-if="!isEdit || type === 'device'"
            rules="required"
            vid="typeAppendix"
            name="Loại PL/BB"
          >
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label">
                Loại PL/BB<span style="color: red"> *</span>
              </label>
              <div class="col-sm-9">
                <Select2 v-model="dataRequest.typeAppendix" :options="typeAppendixOptions" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider
            v-if="!isEdit || type === 'mc' || type === 'area'"
            rules="required"
            vid="customerId"
            name="Merchant"
          >
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label">
                Merchant<span style="color: red"> *</span>
              </label>
              <div class="col-sm-9">
                <input
                  type="hidden"
                  class="form-control text-left"
                  v-model="dataRequest.customerId"
                />
                <input
                  :disabled="isEdit && type === 'area'"
                  type="text"
                  class="form-control text-left"
                  :value="
                    merchantSelected && merchantSelected.merchantName
                      ? `${merchantSelected.merchantName}`
                      : ''
                  "
                  placeholder="Chọn merchant"
                  v-b-modal.select-merchant-dialog-add-device
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider
            v-if="dataRequest.customerId && (!isEdit || type === 'mc' || type === 'area')"
            rules="required"
            vid="locId"
            name="ĐCCNTT"
          >
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label">
                ĐCCNTT<span style="color: red"> *</span>
              </label>
              <div class="col-sm-9">
                <Select2 v-model="dataRequest.locId" :options="locIdOptions" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
          <ValidationProvider v-if="isEdit" rules="required" vid="reason" name="Lý do">
            <div class="form-group row" slot-scope="{ errors }">
              <label class="col-sm-3 col-form-label">
                Lý do<span style="color: red"> *</span>
              </label>
              <div class="col-sm-9">
                <input type="text" v-model="dataRequest.reason" />
                <p class="text-danger">{{ errors[0] }}</p>
              </div>
            </div>
          </ValidationProvider>
        </div>
        <button type="submit" class="btn btn-success float-right ml-2">Lưu</button>
        <button
          @click="$bvModal.hide('_form_device')"
          type="button"
          class="btn float-right btn-outline-secondary"
        >
          Huỷ
        </button>
      </form>
    </ValidationObserver>
    <SelectMerchant
      dialogId="select-merchant-dialog-add-device"
      @selectMerchant="onSelectMerchant"
    />
    <VueLoadingOverlay
      style="z-index: 5 !important"
      :active.sync="showLoading"
      :is-full-page="false"
    ></VueLoadingOverlay>
  </div>
</template>
<script>
  import SelectMerchant from '@/components/SelectMerchant.vue'
  import { MerchantService } from '@/services/merchant.service'
  export default {
    props: {
      isEdit: Boolean,
      type: String,
      item: {
        type: Object,
      },
      deviceTypeOptions: {
        type: Array,
      },
      typeAppendixOptions: {
        type: Array,
      },
    },
    components: { SelectMerchant },
    data() {
      return {
        dataRequest: {},
        showLoading: false,
        merchantSelected: {},
        locIdOptions: [],
      }
    },
    async created() {
      if (this.isEdit && this.type === 'device') {
        this.dataRequest = {
          id: this.item.dataId,
          deviceType: this.item.deviceType,
          typeAppendix: this.item.typeAppendix,
          serial: this.item.serial,
        }
      }
      if (this.isEdit && (this.type === 'mc' || this.type === 'area')) {
        this.showLoading = true
        this.dataRequest = {
          id: this.item.dataId,
          locId: this.item.locId,
          customerId: this.item.customerId,
          serial: this.item.serial,
        }
        this.merchantSelected.merchantName = this.item.merchantName
        await this.getLocIdOptions()
        this.showLoading = false
      }
    },
    methods: {
      onSelectMerchant(mc) {
        this.merchantSelected = mc
        this.dataRequest.customerId = mc.customerId
        this.getLocIdOptions()
      },
      async getLocIdOptions() {
        const res = await MerchantService.listLocMcId({
          customerId: this.dataRequest.customerId,
        })
        this.locIdOptions = res?.data?.map(s => ({ id: s.id, text: s.areaName })) ?? []
      },
      async submitRequest() {
        this.showLoading = true
        try {
          if (this.isEdit && this.type === 'device') {
            const res = await MerchantService.updateDeviceInfoLocation(this.dataRequest)
            if (res.success) {
              this.showSuccessMx('Sửa thông tin thiết bị thành công').then(s =>
                this.$bvModal.hide('_form_device')
              )
            } else this.showFailMx(res.message ?? res.error)
          } else if (this.isEdit && this.type === 'mc') {
            const res = await MerchantService.updateMerchantInfoLocation(this.dataRequest)
            if (res.success) {
              this.showSuccessMx('Sửa thông tin merchant thành công').then(s =>
                this.$bvModal.hide('_form_device')
              )
            } else this.showFailMx(res.message ?? res.error)
          } else if (this.isEdit && this.type === 'area') {
            const res = await MerchantService.updateMerchantAreaLocation(this.dataRequest)
            if (res.success) {
              this.showSuccessMx('Sửa thông tin DCNTT thành công').then(s =>
                this.$bvModal.hide('_form_device')
              )
            } else this.showFailMx(res.message ?? res.error)
          } else {
            const res = await MerchantService.createDeviceLocation(this.dataRequest)
            if (res.success) {
              this.showSuccessMx('Thêm mới thông tin thiết bị thành công').then(s =>
                this.$bvModal.hide('_form_device')
              )
            } else this.showFailMx(res.message ?? res.error)
          }
        } catch (error) {
          this.showFailMx(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
<style scoped></style>
